import React from 'react';

type TodoPostitCardActionsProps = {
  canCopy?: boolean;
  isFavorite: boolean;
  onDuplicate?: () => void;
  onToggleFavorite: () => void;
  onActionPointerDown?: () => void;
};

const TodoPostitCardActions: React.FC<TodoPostitCardActionsProps> = ({
  canCopy = false,
  isFavorite,
  onDuplicate,
  onToggleFavorite,
  onActionPointerDown,
}) => {
  return (
    <span
      className="cp-todo-note-postit-actions"
      onPointerDown={(e) => {
        e.stopPropagation();
        onActionPointerDown?.();
      }}
      onPointerUp={(e) => e.stopPropagation()}
      onPointerCancel={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
      onMouseUp={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      {canCopy && onDuplicate ? (
        <button
          type="button"
          className="cp-todo-note-postit-icon-btn"
          aria-label="복제"
          title="복제"
          onClick={(e) => {
            e.stopPropagation();
            onDuplicate();
          }}
        >
          <svg viewBox="0 0 24 24" width="14" height="14" aria-hidden>
            <path
              fill="currentColor"
              d="M16 1H4c-1.1 0-2 .9-2 2v12h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
            />
          </svg>
        </button>
      ) : null}
      <button
        type="button"
        className={'cp-todo-note-postit-icon-btn is-star' + (isFavorite ? ' is-on' : '')}
        aria-label={isFavorite ? '즐겨찾기 해제' : '즐겨찾기'}
        aria-pressed={isFavorite}
        title={isFavorite ? '즐겨찾기 해제' : '즐겨찾기'}
        onClick={(e) => {
          e.stopPropagation();
          onToggleFavorite();
        }}
      >
        <svg viewBox="0 0 24 24" width="15" height="15" aria-hidden>
          <path
            className="cp-todo-note-postit-star"
            d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
          />
        </svg>
      </button>
    </span>
  );
};

export default TodoPostitCardActions;
